import "./style/App.css";
import { AppProvider } from "./AppContext";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

function App() {
  return (
    <Router>
   <Switch> 
        <Route path="/:id"> <AppProvider /></Route>
    </Switch>
 </Router>
  );
}

export default App;
